import { put, take, fork } from 'redux-saga/effects'
import {
    DeleteTagRequestPayload,
    SavePartiposterTagRequestPayload,
    UpdatePartiposterTagRequestPayload,
    getPartiposterTagList as getPartiposterTagListAPI,
    savePartiposterTag as savePartiposterTagAPI,
    deletePartiposterTag as deletePartiposterTagAPI,
    updatePartiposterTag as updatePartiposterTagAPI,
    GetPartiposterTagListRequestPayload,
} from 'services/api/partiposter'
import {
    closeDeleteTagModal,
    closeProfileTagModal,
    closeTagModal,
    deletePartiposterTag,
    PartiposterActions,
    PartiposterTag,
    PartiposterTagType,
    savePartiposterTag,
    savePartiposterTagList,
    setTagModalErrors,
    updatePartiposterTag,
} from 'state/partiposter'
import { STATE_KEYS } from 'state/requests'
import { handleRequest } from './requests'
import _ from 'lodash'
import i18n from 'config/i18n'

export function* handleGetPartiposterTagListRequest(payload: GetPartiposterTagListRequestPayload): any {
    yield handleRequest<GetPartiposterTagListRequestPayload, PartiposterTag[]>({
        stateKey:
            payload.type === PartiposterTagType.ADD
                ? STATE_KEYS.GetPartiposterTagAddList
                : STATE_KEYS.GetPartiposterTagHistoryList,
        payload,
        ApiHandler: getPartiposterTagListAPI,
        *onSuccess(response) {
            if (response && response.data) {
                const { data } = response.data
                yield put(
                    savePartiposterTagList({
                        // Note: empty data from backend should be [], but it's {} for now
                        data: _.isEmpty(data) ? [] : data,
                        type: payload.type,
                    }),
                )
            }
        },
    })
}

export function* watchGetPartiposterTagListRequestFlow(): any {
    while (true) {
        const action = yield take(PartiposterActions.GET_PARTIPOSTER_TAG_LIST_REQUEST)
        yield fork(handleGetPartiposterTagListRequest, action.payload)
    }
}

export function* handleSavePartiposterTagRequest(payload: SavePartiposterTagRequestPayload): any {
    yield handleRequest<SavePartiposterTagRequestPayload, PartiposterTag>({
        stateKey: STATE_KEYS.SavePartiposterTag,
        payload,
        ApiHandler: savePartiposterTagAPI,
        *onSuccess(response) {
            if (response && response.data) {
                const { data } = response.data
                yield put(
                    savePartiposterTag({
                        tags: Array.isArray(data) ? data : [data],
                        submissionUuid: payload.submissionUuid,
                        profileUuid: payload.profileUuid,
                    }),
                )
                yield put(closeTagModal())
                yield put(closeProfileTagModal())
            }
        },
        *onError(response) {
            if (response && response.validation_errors && response.validation_errors.length > 0) {
                const tagModalErrors = response.validation_errors.map((e: any) => {
                    if (!_.isEmpty(e)) {
                        if (e.tag_uuid.code === 'TAG_DUPLICATE')
                            return {
                                uuid: i18n.t(
                                    'profile.tagging.add.validation.duplicateTag',
                                    'Partiposter already has the tag(s) highlighted in red for this campaign. Check the Tag History for more details.',
                                ),
                            }
                    }
                    return {}
                })
                yield put(setTagModalErrors(tagModalErrors))
            }
        },
    })
}

export function* watchSavePartiposterTagRequestFlow(): any {
    while (true) {
        const action = yield take(PartiposterActions.SAVE_PARTIPOSTER_TAG_REQUEST)
        yield fork(handleSavePartiposterTagRequest, action.payload)
    }
}

export function* handleUpdatePartiposterTagRequest(payload: UpdatePartiposterTagRequestPayload): any {
    yield handleRequest<UpdatePartiposterTagRequestPayload, PartiposterTag>({
        stateKey: STATE_KEYS.UpdatePartiposterTag,
        payload,
        ApiHandler: updatePartiposterTagAPI,
        *onSuccess() {
            yield put(updatePartiposterTag(payload))
            yield put(closeTagModal())
            yield put(closeProfileTagModal())
        },
    })
}

export function* watchUpdatePartiposterTagRequestFlow(): any {
    while (true) {
        const action = yield take(PartiposterActions.UPDATE_PARTIPOSTER_TAG_REQUEST)
        yield fork(handleUpdatePartiposterTagRequest, action.payload)
    }
}

export function* handleDeletePartiposterTagRequest(payload: DeleteTagRequestPayload): any {
    yield handleRequest<DeleteTagRequestPayload, any>({
        stateKey: STATE_KEYS.DeletePartiposterTag,
        payload,
        ApiHandler: deletePartiposterTagAPI,
        *onSuccess() {
            yield put(deletePartiposterTag(payload))
            yield put(closeDeleteTagModal())
        },
    })
}

export function* watchDeletePartiposterTagRequestFlow(): any {
    while (true) {
        const action = yield take(PartiposterActions.DELETE_PARTIPOSTER_TAG_REQUEST)
        yield fork(handleDeletePartiposterTagRequest, action.payload)
    }
}
